"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * reef REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandToJSON = exports.HandFromJSONTyped = exports.HandFromJSON = void 0;
function HandFromJSON(json) {
    return HandFromJSONTyped(json, false);
}
exports.HandFromJSON = HandFromJSON;
function HandFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.HandFromJSONTyped = HandFromJSONTyped;
function HandToJSON(value) {
    return value;
}
exports.HandToJSON = HandToJSON;
